import { Koi } from '@ksyos/koi';
import type { CaroNotificationData } from '@common/customControls/bariatrics';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { CaroNotificationType } from '@common/enums';

export type BariPreCaroAccountNotActivatedNotificationData =
    CaroNotificationData<CaroNotificationType.accountNotActivated>;

const bariPreCaroAccountNotActivatedNotificationFinal: TypedSchema<BariPreCaroAccountNotActivatedNotificationData> = {
    dueDate: Koi.string().isoDate(),
    type: Koi.koi().valid(CaroNotificationType.accountNotActivated),
};

export const bariPreCaroAccountNotActivatedNotificationDraftSchema = Koi.object(
    bariPreCaroAccountNotActivatedNotificationFinal
);
export const bariPreCaroAccountNotActivatedNotificationFinalSchema = Koi.object(
    bariPreCaroAccountNotActivatedNotificationFinal
);
